module.exports = __webpack_public_path__ + "img/level2addon_running_shadow.c6e3b910.png";